import script from "./TressCheckoutAddressOption.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressCheckoutAddressOption.vue?vue&type=script&lang=ts&setup=true"

import "./TressCheckoutAddressOption.vue?vue&type=style&index=0&id=298f8c8f&lang=scss"

const __exports__ = script;

export default __exports__